import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import {
  FETCH_NEW_TOKEN,
  FETCH_TOKEN,
  FORGOT_PASSWORD_SEND_SMS,
  FORGOT_PASSWORD_UPDATE_PASSWORD,
  FORGOT_PASSWORD_VERIFY_CODE,
  LOGOUT,
} from "../constants/auth";
import { State } from "../reducers/root";
import { GenericAction } from "../types";

export function fetchToken(tel: string, password: string, captcha: string): GenericAction<typeof FETCH_TOKEN> {
  return {
    type: FETCH_TOKEN,
    api: true,
    payload: {
      method: "POST",
      url: "/auth/login",
      data: { tel, password, captcha, deviceInfo: {} },
    },
  };
}

export function fetchNewToken(refreshToken: string) {
  return {
    type: FETCH_NEW_TOKEN,
    api: true,
    payload: {
      method: "POST",
      url: "/auth/refresh",
      data: { refresh: refreshToken },
    },
  };
}

type LoginData = {
  tel: string;
  password: string;
  captcha: string;
};

export function loginUser({ tel, password, captcha }: LoginData): ThunkAction<void, State, undefined, AnyAction> {
  return async (dispatch) => {
    await dispatch(fetchToken(tel, password, captcha));
  };
}

export function requestLogout() {
  return { type: LOGOUT };
}

export function logoutUser(): ThunkAction<void, State, undefined, AnyAction> {
  return function (dispatch) {
    dispatch(requestLogout());
  };
}

export function forgotPasswordSendSms({ tel }: { tel: string }) {
  const data = { tel };
  return {
    type: FORGOT_PASSWORD_SEND_SMS,
    api: true,
    // usePapi: true,
    payload: {
      method: "PATCH",
      url: "/forgot-password/send-sms",
      data,
    },
  };
}

export function forgotPasswordVerifyCode(data: { tel: string; smsKey: string }) {
  return {
    type: FORGOT_PASSWORD_VERIFY_CODE,
    api: true,
    // usePapi: true,
    payload: {
      method: "PATCH",
      url: "/forgot-password/check-sms-key",
      data,
    },
  };
}

type ForgotData = {
  password: string;
  password2: string;
  code: string;
};

export function forgotPasswordUpdatePassword({ password, password2, code }: ForgotData) {
  const data = { password, password2, code };
  return {
    type: FORGOT_PASSWORD_UPDATE_PASSWORD,
    api: true,
    // usePapi: true,
    payload: {
      method: "PATCH",
      url: "/forgot-password/update-password",
      data,
    },
  };
}
